<template>
  <div>
    <b-container>
      <nav-bar :title="'Task Timer'"></nav-bar>

      <div v-if="getPendingTasksNoComplete != 0" class="mx-sm-5">
        <p class="mt-2 mb-1">
          Choose a task to start the stopwatch/timer.
        </p>

        <b-input-group class="mb-2">
          <b-input-group-prepend is-text>
            <i class="material-icons">
              search
            </i>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="search"
            placeholder="Search title task..."
          ></b-form-input>
        </b-input-group>

        <select-task :tasks="filteredList" class="mb-5"></select-task>
      </div>

      <div v-else class="text-center mx-2 mt-5">
        <i
          class="material-icons border-2 full-icon rounded-circle align-middle mt-5 mb-4 border-0"
        >
          assignment
        </i>
        <p class="h4 text-xmuted mx-4">
          You have no tasks added yet.
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import navBar from '@/components/atmNavBar';
import selectTask from '@/components/Timer/atmSelectTask';

export default {
  data() {
    return {
      search: ''
    };
  },
  components: {
    navBar,
    selectTask
    //taskTimer,
    //timer
  },
  computed: {
    ...mapGetters('task', ['getTodayTasks', 'getPendingTasksNoComplete']),
    filteredList() {
      return this.getPendingTasksNoComplete.filter(item => {
        return item.title.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  async beforeRouteEnter(to, from, next) {
    let childId = store.getters['user/getUserId'];
    await Promise.all([
      store.dispatch('task/fetchPendingTasks', childId),
      store.dispatch('task/fetchTodayTasks', childId)
    ]);
    next();
  }
};
</script>

<style scoped>
.input-group-text {
  background-color: #ffffff !important;
  border-right: 0 !important;
  padding: 0px 5px;
}
.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  border-left: 0 !important;
  padding-left: 2px;
}
</style>
